import {
  Box,
  Grid,
  IconButton,
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Autocomplete,
  TextField,
  Card,
  CardContent,
  CardHeader,
  CardActions,
  Step,
  StepLabel,
  Stepper,
  Avatar,
  CircularProgress,
  Skeleton,
  styled,
  MenuItem,
  ListItemText,
  Dialog,
  DialogContent,
  DialogTitle,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useBottomBar } from "../../../contexts/BottomButtonsContext";
import SendIcon from "@mui/icons-material/Send";
import { format, addDays, startOfWeek, addWeeks, startOfDay, isBefore } from "date-fns";
import { ru, ro } from "date-fns/locale";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { CheckCircleOutline, ContentPasteOffSharp, ErrorOutline } from "@mui/icons-material";
import { ArrowBackIos, ArrowForwardIos, Event } from "@mui/icons-material";
import { PatientCalendarDoctorDTO, PatientCalendarSlotDTO } from "../../../api/PatientCalendar/PatientCalendarClientDTO";
import { PatientCalendarClient } from "../../../api/PatientCalendar/PatientCalendarClient";
import { REACT_APP_PORTAL_API_URL } from "../../../KeyVariables";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Client } from "../../../core/DashboardApi/api";
import { ShoppingCartClient } from "../../../api/ShoppingCart/ShoppingCartClient";


const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: 8, // Закругленные углы
    padding: "10px", // Увеличенный внутренний отступ
    backgroundColor: theme.palette.background.paper, // Фон в стиле Material UI
  },
  "& .MuiAutocomplete-popupIndicator": {
    color: theme.palette.primary.main, // Цвет стрелки вниз
  },
}));

const StyledCardContent = styled(CardContent)({
  padding: "20px",
});

const CustomPaper = (props: any) => (
  <Box
    component="ul"
    sx={{
      backgroundColor: "white",
      borderRadius: 2,
      boxShadow: 3,
      padding: "5px 10px",
    }}
    {...props}
  />
);


const generateWeekDays = (date: Date): Date[] => {
  const start = startOfWeek(date, { weekStartsOn: 1 });
  return Array.from({ length: 7 }, (_, i) => addDays(start, i));
};

function Calendar() {
  const { i18n } = useTranslation("Portal");
  const [services, setServices] = useState<any[]>([]);
  const [medicalProfiles, setMedicalProfiles] = useState<any[]>([]);
  const [doctors, setDoctors] = useState<PatientCalendarDoctorDTO[]>([]);
  const [allDoctors, setAllDoctors] = useState<PatientCalendarDoctorDTO[]>([]);



  const [currentWeek, setCurrentWeek] = useState<Date>(new Date());
  const [selectedService, setSelectedService] = useState<any>(null);
  const [selectedProfile, setSelectedProfile] = useState<any>(null);
  const [selectedDoctor, setSelectedDoctor] = useState<any>(null);
  const [selectedSlot, setSelectedSlot] = useState<any>(null);
  const [clinics, setClinics] = useState<any[]>([]);
  const [selectedClinic, setSelectedClinic] = useState<any>({ id: 1, name: "Burebista" });
  const [activeStep, setActiveStep] = useState(0);

  const fetch = async () => {
    try {
      const res = await patientCalendarClient.getclinics()
      setClinics(res)
    }
    catch (ex) {
      console.error(ex);
    }
    finally {

    }
  }
  useEffect(() => {
    fetch();
  }, [])

  const weekDays = generateWeekDays(currentWeek);

  const [searchTerm, setSearchTerm] = useState<string>("");
  const [loadingServices, setLoadingServices] = useState(false);
  const [loadingDoctors, setLoadingDoctors] = useState(false);

  const patientCalendarClient = new PatientCalendarClient(REACT_APP_PORTAL_API_URL);


  const [searchParams, setSearchParams] = useSearchParams();

  const fetchServices = async (query: string | undefined) => {
    try {
      const response = await patientCalendarClient.servicesautocomplete(query);
      return response;
    } catch (error) {
      console.error("Ошибка запроса:", error);
      return [];
    }
  };

  const fetchOneService = async (serviceId) => {
    setLoadingServices(true);

    const res = await patientCalendarClient.servicebyid(Number(serviceId))
    if (res) {
      handleChangeService(res)
      setServices([res]);
    }
    setLoadingServices(false);
  }
  const doctorId = useMemo(() => Number(searchParams.get("doctorId")), [searchParams]);
  const medicalProfileId = useMemo(() => Number(searchParams.get("medicalProfileId")), [searchParams]);

  useEffect(() => {
    if (doctorId > 0) {
      console.log(allDoctors)
      const doctor = allDoctors.find(s => s.id === doctorId);
      if (doctor) {
        setSelectedDoctor(doctor);
        setActiveStep(3)
        handleProfileChange(null, doctor.medicalProfile);
      }
    }

    if (medicalProfileId > 0) {
      const medicalProfile = medicalProfiles.find(s => s.id === medicalProfileId);
      if (medicalProfile) {
        handleProfileChange(null, medicalProfile);
      }
    }
  }, [doctorId, medicalProfileId, allDoctors, medicalProfiles]);

  useEffect(() => {
    const serviceId = searchParams.get("serviceId");
    if (serviceId && Number(serviceId) > 0) {
      fetchOneService(Number(serviceId));
    }
    else {
      const delayDebounceFn = setTimeout(async () => {

        setLoadingServices(true);
        console.log(searchTerm);
        const result = await fetchServices(searchTerm);
        setServices(result);
        setLoadingServices(false);
      }, 500);
      return () => clearTimeout(delayDebounceFn);
    }

  }, [searchTerm, searchParams]);

  const handleWeekChange = (direction: number) => {
    setCurrentWeek((prev) => addWeeks(prev, direction));
  };

  const getLocale = () => (i18n.language === "ru" ? ru : ro);


  const fetchDoctors = async () => {
    try {
      setLoadingDoctors(true);
      const response = await patientCalendarClient.doctorsbyservicesandmedicalprofileautocomplete("", selectedService?.id)
      if (response) {
        setDoctors(response);
        setAllDoctors(response);
        const uniqueMedicalProfiles = Array.from(
          new Map(
            response
              .filter(d => d.medicalProfile && d.medicalProfile.id) // Фильтруем, чтобы medicalProfile и его id были определены
              .map(d => [d.medicalProfile?.id, d.medicalProfile])
          ).values()
        );
        setMedicalProfiles(uniqueMedicalProfiles);
      }

    }
    catch (ex) {
      console.error(ex);
    }
    finally {
      setLoadingDoctors(false);
    }
  }
  const handleProfileChange = (_: any, newValue: any | null) => {
    setSelectedProfile(newValue)
    setSelectedProfile(newValue);

    if (!newValue) {
      setDoctors(allDoctors); // Если профиль сброшен, возвращаем весь список
      return;
    }

    // Фильтруем врачей по выбранному профилю
    const filteredDoctors = allDoctors.filter((doctor) => doctor.medicalProfile?.id === newValue?.id);
    setDoctors(filteredDoctors);
  };
  useEffect(() => {
    if (selectedService) {
      fetchDoctors();
    }
  }, [selectedService])
  const [availableSlots, setAvailableSlots] = useState<any>();
  const [loadingCalendar, setLoadingCalendar] = useState(false); // Состояние загрузки

  const fetchAvailableSlots = async () => {
    if (!selectedDoctor?.id || selectedDoctor.id <= 0) return;

    setLoadingCalendar(true);

    try {
      const response = await patientCalendarClient.getemptyslots(
        selectedDoctor.id,
        selectedService?.id,
        selectedClinic?.id,
        currentWeek
      );

      if (response && Array.isArray(response)) {
        // Проверяем, что response является массивом
        const groupedSlots = response.reduce((acc, slot) => {
          if (!slot?.startDate) return acc; // Проверяем, что у слота есть startDate

          const dateKey = format(new Date(slot.startDate), "yyyy-MM-dd");
          if (!acc[dateKey]) {
            acc[dateKey] = [];
          }
          acc[dateKey].push(slot);

          return acc;
        }, {} as Record<string, PatientCalendarSlotDTO[]>);

        setAvailableSlots(groupedSlots);
      } else {
        console.warn("Получены некорректные данные от API");
        setAvailableSlots({}); // Сбрасываем в пустой объект, чтобы избежать ошибок
      }
    } catch (error) {
      console.error("Ошибка при загрузке слотов:", error);
      setAvailableSlots({}); // В случае ошибки сбрасываем слоты
    } finally {
      setLoadingCalendar(false);
    }
  };

  useEffect(() => {
    if (selectedDoctor?.id && selectedDoctor.id > 0) {
      fetchAvailableSlots();
    }
  }, [selectedDoctor, currentWeek]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { setElement, setElementLeft } = useBottomBar();
  useEffect(() => {

    const defaultElements = (
      <Box display={"flex"} gap={2}>


        <Button
          sx={{ px: 2 }}
          color="info"
          variant="contained"
          onClick={() =>
            navigate(
              '/'
            )
          }
          endIcon={<SendIcon />}
        >
          {"Inapoi"}
        </Button>
        {/* {patientId > 0 && advancedAccess ? (
          <>
            <IconButton sx={{ px: 2, color: "HighlightText" }}>
              <SettingsIcon />
            </IconButton>
          </>
        ) : null} */}
      </Box>
    );

    setElement(defaultElements);


    return () => {
      setElement(null);
      setElementLeft(null);
    };
  }, [
    isMobile,
    setElement,
    setElementLeft,
  ]);

  const isStepCompleted = (step: number) => {
    switch (step) {
      case 0:
        return !!selectedService;
      case 1:
        return !!selectedDoctor;
      case 2:
        return !!selectedSlot;
      default:
        return false;
    }
  };
  const [loadingCreation, setLoadingCreation] = useState(false)
  const [successCreation, setSuccessCreation] = useState(false)
  const [error, setError] = useState(null);
  const [open, setOpen] = useState(false);
  const onClose = () => {
    setOpen(false);
  }
  const [step, setStep] = useState("confirm");
  const navigate = useNavigate();

  const shoppingCartItemId = searchParams.get("shoppingCartItemId");




  const shoppingCartClient = new ShoppingCartClient(REACT_APP_PORTAL_API_URL);

  const handleCreate = async () => {
    setStep("loading");
    setError(null);
    const consultationId = searchParams.get("consultationId");
    const investigationId = searchParams.get("investigationId");

    try {
      const objectToSave = {
        startDate: selectedSlot.startDate,
        endDate: selectedSlot.endDate,
        doctorId: selectedDoctor?.id,
        doctorName: selectedDoctor?.name,
        service: { id: selectedService?.id },
        appointmentType: { id: 1, name: "" },
        appointmentStatus: { id: 7, name: "" },
        schedulerBlockType: { id: 1, name: "" },
        clinic: selectedClinic,
      } as any;
      if (consultationId && Number(consultationId) > 0) {
        objectToSave.consultation = { id: consultationId };
      }

      if (investigationId && Number(investigationId) > 0) {
        objectToSave.presentationInvestigationTypeId = { id: investigationId };
      }

      const response = await patientCalendarClient.createAppointment(objectToSave);

      if (response) {
        setSuccessCreation(true);
        setStep("success");

        if (shoppingCartItemId && Number(shoppingCartItemId)) {
          const res = await shoppingCartClient.updatestatus(Number(shoppingCartItemId))
        }
        setTimeout(() => {
          onClose();
          navigate("/");
        }, 3000);
      }
    } catch (ex) {
      setError("A aparut erroare.");
      setStep("error");
    }
  };
  const serviceIdFromParams = searchParams.get("serviceId");
  const handleChangeService = (newValue) => {
    setSelectedService(newValue);
    if (newValue?.id > 0) {
      setActiveStep(1);
    } else {
      setActiveStep(0);
      setSelectedClinic(null);
      setSelectedDoctor(null);
      setSelectedProfile(null);
    }
  }
  const { t } = useTranslation("Portal");

  useEffect(() => {
    console.log(activeStep)
    console.log(selectedClinic)
    console.log(selectedDoctor)
  }, [activeStep]);

  const steps = [t("Portal_SelectService"), t("Portal_SelectClinic"), t("Portal_SelectDoctor"), t("Portal_SelectSlot")];
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Grid container spacing={2} sx={{ p: 3 }}>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>
          {step === "confirm"
            ? t("Portal_Confirmation")
            : step === "loading"
              ? (t("Portal_Creating"))
              : step === "success"
                ? t("Portal_CreationSuccess")
                : t("Portal_Error")}
        </DialogTitle>
        <DialogContent style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "20px" }}>
          {/* Подтверждение записи */}
          {step === "confirm" && selectedSlot && selectedDoctor && selectedService && (
            <Box sx={{ textAlign: "center" }}>
              <Avatar
                sx={{ width: 80, height: 80, mx: "auto", mb: 1 }}
                src={selectedDoctor.photo || "/placeholder.jpg"}
              />
              <Typography variant="h6" fontWeight="bold">
                {selectedDoctor.name}
              </Typography>
              <Typography variant="body1">{selectedDoctor?.medicalProfile?.name}</Typography>
              <Typography variant="body1">{selectedService.name}</Typography>
              <Typography variant="body1">
                <Typography variant="body2" fontWeight="bold" fontSize={14}>
                  {format(new Date(selectedSlot.startDate), "dd.MM.yyyy", { locale: getLocale() })}
                </Typography>
                {format(new Date(selectedSlot.startDate), "HH:mm", { locale: getLocale() })} -{" "}
                {format(new Date(selectedSlot.endDate), "HH:mm", { locale: getLocale() })}
              </Typography>

              <Button variant="contained" color="primary" size="large" sx={{ mt: 2 }} onClick={() => handleCreate()}>
                {t("Portal_Programming")}
              </Button>
            </Box>
          )}

          {/* Загрузка */}
          {step === "loading" && <CircularProgress />}

          {/* Успех */}
          {step === "success" && (
            <>
              <CheckCircleOutline style={{ fontSize: 80, color: "green", marginBottom: "20px" }} />
              <Typography variant="h6">  {t("Portal_CreationSuccess")}</Typography>
              <Typography variant="body1">  {t("Portal_Redirecting")}</Typography>
            </>
          )}

          {/* Ошибка */}
          {step === "error" && (
            <>
              <ErrorOutline style={{ fontSize: 80, color: "red", marginBottom: "20px" }} />
              <Typography variant="h6">{error}</Typography>
              <Button onClick={() => setStep("confirm")} variant="contained" color="primary" sx={{ mt: 2 }}>
                {t("Portal_TryAgain")}
              </Button>
            </>
          )}
        </DialogContent>
      </Dialog>
      <Grid item xs={12} md={4}>
        <Card>
          <CardHeader title={t("Portal_Programming")} />
          <StyledCardContent>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
              <StyledAutocomplete
                disablePortal
                options={services}
                disabled={!!serviceIdFromParams}
                loadingText={<>
                  <CircularProgress color="inherit" size={20} />
                </>}
                getOptionLabel={(option) => option?.name ?? ""}
                value={selectedService}
                loading={loadingServices}
                onInputChange={(_, newInputValue) => setSearchTerm(newInputValue)}
                onChange={(_, newValue) => {
                  handleChangeService(newValue)
                }}
                renderOption={(props, option) => (
                  <MenuItem {...props}>
                    <ListItemText primary={option.name} />
                  </MenuItem>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t("Portal_SelectService")}
                    variant="outlined"
                    fullWidth
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loadingServices ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
              {
                activeStep > 0
                &&
                <TextField
                  select
                  label={t("Portal_SelectClinic")}
                  fullWidth
                  value={selectedClinic}
                  onChange={(event) => { setSelectedClinic(event.target.value); setActiveStep(2); }}
                >
                  {clinics.map((clinic) => (
                    <MenuItem key={clinic.id} value={clinic}>
                      {clinic.name}
                    </MenuItem>
                  ))}
                </TextField>
              }
              {activeStep > 1 && (
                <StyledAutocomplete
                  disablePortal
                  options={medicalProfiles}
                  getOptionLabel={(option) => option.name}
                  value={selectedProfile}
                  onChange={(_, newValue) => handleProfileChange(_, newValue)}
                  disabled={!selectedService || loadingDoctors || !!doctorId || !!medicalProfileId}
                  renderOption={(props, option) => (
                    <MenuItem {...props}>
                      <ListItemText primary={option.name} />
                    </MenuItem>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t("Portal_SelectProfile")}
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {loadingDoctors ? <CircularProgress color="inherit" size={20} /> : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              )}
              {activeStep > 1 && (
                <StyledAutocomplete
                  disablePortal
                  options={doctors}
                  getOptionLabel={(option) => `${option.name}`}
                  value={selectedDoctor}

                  onChange={(_, newValue) => {
                    setSelectedDoctor(newValue);
                    setActiveStep(3);
                  }}
                  disabled={!selectedService || !!doctorId}
                  renderOption={(props, option) => (
                    <MenuItem {...props}>
                      <ListItemText primary={option.name} />
                    </MenuItem>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t("Portal_SelectDoctor")}
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {loadingDoctors ? <CircularProgress color="inherit" size={20} /> : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              )}
            </Box>
          </StyledCardContent>
          {/* Степпер */}
          <CardActions sx={{ display: "flex", flexDirection: "column", p: 2 }}>
            <Stepper
              activeStep={activeStep}
              orientation={isSmallScreen ? "vertical" : "horizontal"} // Переключение ориентации
              sx={{
                width: "100%",
                alignItems: isSmallScreen ? "flex-start" : "center", // Выравнивание для вертикального режима
              }}
            >
              {steps.map((label, index) => (
                <Step key={index} completed={isStepCompleted(index)}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
            {selectedSlot && selectedDoctor && selectedService && (
              <Box sx={{ mt: 2, textAlign: "center" }}>
                <Avatar
                  sx={{ width: 80, height: 80, mx: "auto", mb: 1 }}
                  src={selectedDoctor.photo || "/placeholder.jpg"}
                />
                <Typography variant="h6" fontWeight={"bold"}>{selectedDoctor.name}</Typography>
                <Typography variant="body1">{selectedDoctor?.medicalProfile?.name}</Typography>
                <Typography variant="body1">{selectedService.name}</Typography>
                <Typography variant="body1" >
                  <Typography variant="body2" fontWeight={"bold"} fontSize={14}>{format(new Date(selectedSlot.startDate), "dd.MM.yyyy", { locale: getLocale() })}</Typography>
                  {format(new Date(selectedSlot.startDate), "HH:mm", { locale: getLocale() })}
                  {" - "}
                  {format(new Date(selectedSlot.endDate), "HH:mm", { locale: getLocale() })}
                </Typography>
                <Button variant="contained" color="primary" size="large" sx={{ mt: 2 }} onClick={() => setOpen(true)}>
                  {t("Portal_Programming")}
                </Button>
              </Box>
            )}
          </CardActions>
        </Card>
      </Grid>
      {/* Правая панель: Выбор слотов */}
      {selectedDoctor && (
        <Grid item xs={12} md={8}>
          <Card>
            <CardContent>
              <Box>
                <Grid container alignItems="center" justifyContent="space-between" sx={{ py: 1 }}>
                  <IconButton onClick={() => handleWeekChange(-1)}>
                    <ArrowBackIos fontSize="small" />
                  </IconButton>
                  <Typography variant="h5">        {t("Portal_AvailableSlots")} </Typography>
                  <IconButton onClick={() => handleWeekChange(1)}>
                    <ArrowForwardIos fontSize="small" />
                  </IconButton>
                </Grid>
                <TableContainer sx={{ overflowX: "auto" }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        {weekDays.map((day, index) => (
                          <TableCell key={index} align="center">
                            <Typography variant="h6">{format(day, "dd.MM.yyyy")}</Typography>
                            <Typography variant="body2">
                              {format(day, "EEEE", { locale: getLocale() })}
                            </Typography>
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        {weekDays.map((day, index) => {
                          const formattedDate = format(day, "yyyy-MM-dd");
                          const today = startOfDay(new Date());
                          const isPastDate = isBefore(startOfDay(day), today);
                          const slots = availableSlots && formattedDate in availableSlots ? availableSlots[formattedDate] : [];

                          return (
                            <TableCell
                              key={index}
                              sx={{
                                border: "1px solid #ccc",
                                verticalAlign: "top",
                                backgroundColor: isPastDate ? "rgba(88,88,88, 0.3)" : slots ? "inherit" : "rgba(248,215,218, 0.3)",
                              }}
                              align="center"
                            >
                              {loadingCalendar ? ( // Если загрузка, показываем Skeleton
                                <Skeleton variant="rectangular" width={80} height={30} />
                              ) : isPastDate ? (
                                <Typography variant="body2" color="textSecondary">
                                  {t("Portal_Indisponsible")}
                                </Typography>
                              ) : slots?.length ? (
                                <Box
                                  sx={{
                                    display: "grid",
                                    gridTemplateColumns: isSmallScreen ? "1fr" : "1fr 1fr", // 1 колонка на маленьких экранах, 2 на больших
                                    gap: 0.5,
                                    justifyContent: "center",
                                  }}
                                >
                                  {
                                    slots.map((slot, idx) => (
                                      <Button
                                        key={idx}
                                        variant={selectedSlot?.startDate === slot.startDate && selectedSlot?.endDate === slot.endDate ? "contained" : "outlined"}
                                        size="medium"
                                        sx={{
                                          fontSize: "11px",
                                          px: 4,
                                          backgroundColor: selectedSlot?.startDate === slot.startDate && selectedSlot?.endDate === slot.endDate ? "#1976d2" : "transparent", // Цвет заливки
                                          color: selectedSlot?.startDate === slot.startDate && selectedSlot?.endDate === slot.endDate ? "#fff" : "inherit", // Белый текст для выбранного
                                          "&:hover": {
                                            backgroundColor: selectedSlot?.startDate === slot.startDate && selectedSlot?.endDate === slot.endDate ? "#1565c0" : "#f0f0f0" // Темнее при hover
                                          },
                                        }}
                                        onClick={() => {
                                          setSelectedSlot(slot);
                                          setActiveStep(4);
                                        }}
                                      >
                                        {format(new Date(slot.startDate), "HH:mm")}-
                                        {format(new Date(slot.endDate), "HH:mm")}
                                      </Button>

                                    ))
                                  }
                                </Box>
                              ) : (
                                <Typography variant="body2" color="textSecondary">
                                  {t("Portal_DoctorNotWorking")}
                                </Typography>
                              )}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      )}
    </Grid>
  );
}

export default Calendar;
